import type { CompassProduct } from "../contexts/CompassContext";
import {
  compassProducts as compassProductEntities,
  filterProducts as filterProductEntities,
  getProductsByTrend as getTrendProductEntities,
} from "../data/entity_sets/compassProducts";

import { faireProductToCompassProduct } from "./compassProductFromEntity";

export const compassProducts: CompassProduct[] = compassProductEntities.map(
  (product) => ({
    ...faireProductToCompassProduct(product),
    category: product.categoryTokens?.[0],
    categories: product.categoryTokens,
  })
);

export const filterProducts = (
  products: CompassProduct[],
  filters: {
    categories?: string[];
    tags?: string[];
    maxWeight?: number;
    maxPrice?: number;
    inStock?: boolean;
  }
): CompassProduct[] => {
  const entityTokens = products.map((product) => product.token);
  const filteredEntities = filterProductEntities(
    compassProductEntities.filter((entity) =>
      entityTokens.includes(entity.token)
    ),
    filters
  );
  const tokens = new Set(filteredEntities.map((entity) => entity.token));
  return products.filter((product) => tokens.has(product.token ?? ""));
};

export const getProductsByTrend = (trendId: string): CompassProduct[] => {
  return getTrendProductEntities(trendId).map((product) => ({
    ...faireProductToCompassProduct(product),
    category: product.categoryTokens?.[0],
    categories: product.categoryTokens,
  }));
};
